class MainHeader extends HTMLElement {
  constructor() {
    super();
    this.resizeTimeout = null;
    this.searchMQ = null;
    this.searchInput = null;
  }

  connectedCallback() {
    window.addEventListener('load', () => {
      this.listsElements = this.querySelectorAll('.megamenu-holder__links');
      this.initElements();
      this.setupBurgerToggle();
      this.setupLinkItemChecks();
      this.setupResizeHandler(this.listsElements);
      this.handleResize();
      this.setupNavHoverEffects();
      this.markLastInRows(this.listsElements);
      this.initSearchPlaceholder();
      this.updateSearchPlaceholder(window.innerWidth < 500);
    });
  }

  initElements() {
    this.toggleButton = this.querySelector('.js-open-menu--mobile');
    this.menu = document.querySelector('.burger-menu-header--popup');
    this.floatMenus = this.querySelectorAll('.megamenu_floating');
    this.floatMenusLinks = this.querySelectorAll('.megamenu_floating .megamenu-holder__links');
    this.mainNavItems = this.querySelectorAll('.nav__list-item');
    this.searchInput = document.querySelector('#search-input-header-mobile');
  }

  initSearchPlaceholder() {
    if (!this.searchInput) return;
    this.searchMQ = window.matchMedia('(max-width: 499px)');
    this.updateSearchPlaceholder(this.searchMQ.matches);
    this.searchMQ.addEventListener('change', (e) => {
      this.updateSearchPlaceholder(e.matches);
    });
  }

  updateSearchPlaceholder(isMobile) {
    if (!this.searchInput) return;
    this.searchInput.placeholder = isMobile ? this.dataset.placeholderMobile : this.dataset.placeholderDesktop;
  }

  setupBurgerToggle() {
    if (!this.toggleButton || !this.menu) return;

    this.toggleButton.addEventListener('click', () => {
      const isActive = this.toggleButton.classList.contains('active');
      this.toggleButton.classList.toggle('active', !isActive);

      if (isActive) {
        document.documentElement.classList.remove('overflow');
        this.menu.classList.remove('open', 'animated');
      } else {
        document.documentElement.classList.add('overflow');
        this.menu.classList.add('open');
        setTimeout(() => this.menu.classList.add('animated'), 10);
      }
    });
  }

  setupResizeHandler(elements) {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.handleResize();
        this.markLastInRows(elements);
        this.updateSearchPlaceholder(window.innerWidth < 500);
      }, 150);
    });
  }

  getChildItemCount(container, selector = '.megamenu-holder__links-item') {
    return container.querySelectorAll(selector).length;
  }

  handleResize() {
    this.floatMenus.forEach((block) => {
      const container = block.querySelector('.megamenu-holder__links');
      const childCount = container ? this.getChildItemCount(container) : 0;

      if (block.offsetWidth <= 600 && childCount >= 2) {
        block.classList.add('narrow');
      } else {
        block.classList.remove('narrow');
      }
    });
  }

  setupNavHoverEffects() {
    this.mainNavItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        const hasMegaMenu = item.querySelector('.megamenu-holder');
        if (hasMegaMenu) {
          document.documentElement.classList.add('overflow');
          document.documentElement.classList.add('megamenu-open');
          item.classList.add('hovered');
        }
      });

      item.addEventListener('mouseleave', () => {
        const hasMegaMenu = item.querySelector('.megamenu-holder');
        if (hasMegaMenu) {
          document.documentElement.classList.remove('overflow');
          document.documentElement.classList.remove('megamenu-open');
          item.classList.remove('hovered');
        }
      });
    });
  }

  setupLinkItemChecks() {
    this.floatMenusLinks.forEach((container) => {
      const childCount = this.getChildItemCount(container);

      if (childCount === 2) {
        container.classList.add('two-in-row');
      }

      if (childCount >= 3) {
        container.classList.add('three-in-row');
      }
    });
  }

  markLastInRows(containers) {
    containers.forEach((container) => {
      const items = Array.from(container.querySelectorAll('.megamenu-holder__links-item'));
      let currentTop = null;
      let lastInRow = null;

      items.forEach((item) => item.classList.remove('last-in-row'));

      items.forEach((item) => {
        const top = item.getBoundingClientRect().top;

        if (currentTop === null || top !== currentTop) {
          if (lastInRow) lastInRow.classList.add('last-in-row');
          currentTop = top;
        }

        lastInRow = item;
      });

      if (lastInRow) lastInRow.classList.add('last-in-row');
    });
  }
}

customElements.define('main-header', MainHeader);
